export default function execGlobalJS(
  script,
  {
    i18nApi,
    restApi,
    messageApi,
    routerApi,
    modalApi,
    //
  },
) {
  (function bindThis() {
    // eslint-disable-next-line no-eval
    eval(script);
  }).call({
    i18nApi,
    restApi,
    messageApi,
    routerApi,
    modalApi,
  });
}
